import gql from 'graphql-tag';

export default {
    createPostMutation: gql`
        mutation CreatePost($campaignID: String!, $email: String, $name: String, $audio: AudioInput, $image: ImageInput, $externalID: String, $rating: Int) {
            createPost(post: { audio: $audio, email: $email, name: $name, image: $image, campaignID: $campaignID, externalID: $externalID, rating: $rating }) {
                _
            }
        }
    `,
};
